import type { MediaParentEntity } from '../../media/media-parent-entity.enum';

export const PLAY_TYPE = {
  EVENT_INFO: 'event-info',
  FLOW_INFO: 'flow-info',
  FLOW_AGENDA: 'flow-agenda',
  SESSION_INFO: 'session-info',
  FLOW_CLOSING: 'flow-closing',
  EVENT_CLOSING: 'event-closing',
  BREAK_INFO: 'break-info',
  LIVE: 'live',
  MEDIA: 'media',
} as const;

export type ControlDeviceDto = {
  entityId: string;
  entityType: 'Media' | 'Flow' | 'Session' | 'Event' | 'Break';
  contextEntityId: string;
  contextEntityType: MediaParentEntity;
  playType: (typeof PLAY_TYPE)[keyof typeof PLAY_TYPE];
  playerId?: string;
  assetVersion?: number;
};
